import React, { useState, useEffect } from "react";

// components
import { Button, FormGroup, Input, Row, Col, Spinner, Label, Collapse, Form, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import Select from 'react-select'

// utils
import { showMessage } from "utils/message.js";

// api
import usuario_api from "api/usuario_api.js";
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api';
import centrocustos_api from "api/centrocustos_api";

// views
import PlanoContasDatasys from "./Components/PlanoContasDatasys";

export default function CentroCustos({ history }) {

    const [showLoading, setshowLoading] = useState(false);

    const [isDisable, set_isDisable] = useState(true);

    // Grupos Econômicos
    const [options_gruposeconomicos, set_options_gruposeconomicos] = useState([]);
    const loadOptionsGruposEconomicos = () => {
        dadosimplantacaotim_api.getGruposEconomicos(null).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _gruposeconomicos = [];
                result.data.map((m) => _gruposeconomicos.push({ label: m, value: m }));
                set_options_gruposeconomicos(_gruposeconomicos);
            }
        })
    }
    const [grupoeconomico, set_grupoeconomico] = useState(null);
    const handleChangeGrupoEconomico = (value) => {
        set_planoContas([]);
        set_grupoeconomico(value.value);
        loadOptionsPlanoContas(value.value);
        handleViewCentroCustos(value.value);
    }

    // Plano de Contas
    const [planoContas, set_planoContas] = useState([]);
    const [planoContasDisabled, set_planoContasDisabled] = useState([]);
    const [planoContasSelected, set_planoContasSelected] = useState([]);
    const [field, set_field] = useState(null);
    const loadOptionsPlanoContas = (_grupoeconomico) => {
        centrocustos_api.getPlanoContasDatasys(_grupoeconomico).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_planoContas(result.data);
            }
        })
    }

    const [isOpenPlanoContasDatasys, set_isOpenPlanoContasDatasys] = useState(false);
    const handleOpenPlanoContasDatasys = (_field) => {
        if (isDisable) {
            showMessage("Aviso", "Seu usuário não tem permissão para editar os planos de contas.", 'error', null);
            return;
        }

        set_field(_field);

        let _planoContasDisabled = [];
        let _planoContasSelected = [];
        for (var key in centroCustos) {
            if (centroCustos.hasOwnProperty(key) && key != "grupoNegocio" && centroCustos[key] && centroCustos[key].indexOf('|') > 0 && centroCustos[key].split('|').length > 0) {
                if (key != _field)
                    _planoContasDisabled = _planoContasDisabled.concat(centroCustos[key].split('|').filter(f => f != ""));
                else
                    _planoContasSelected = centroCustos[key].split('|').filter(f => f != "");
            }
        }
        set_planoContasDisabled(_planoContasDisabled);
        set_planoContasSelected(_planoContasSelected);
        set_isOpenPlanoContasDatasys(true);
    }
    const ReturnPlanoContasDatasys = (planoContasSelecionado) => {
        set_isOpenPlanoContasDatasys(false);
        let _centroCustos = centroCustos;
        _centroCustos[field] = "";
        planoContasSelecionado.map(m => _centroCustos[field] += m.codigo + "|");
        set_centroCustos(_centroCustos);
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("CentroCustos", "Editar").then((result) => { set_isDisable(!result); });

        loadOptionsGruposEconomicos();
    }, []);

    // Centro Custos
    const [centroCustos, set_centroCustos] = useState(null);
    const handleViewCentroCustos = (_grupoeconomico) => {
        setshowLoading(true);
        set_centroCustos(null);
        centrocustos_api.getItem(_grupoeconomico).then(result => {
            setshowLoading(false);
            if (result.status == 204)
                set_centroCustos({ grupoNegocio: _grupoeconomico });
            else if (result.status !== 200)
                showMessage("Aviso", result.message, 'error', null);
            else
                set_centroCustos(result.data);
        })
    }

    const handleClickSalvar = () => {
        let json_submit = centroCustos;
        if (!json_submit.grupoNegocio)
            json_submit.grupoNegocio = grupoeconomico;

        setshowLoading(true);
        centrocustos_api.post(json_submit).then(result => handleReturnSalvar(result));
    }

    const handleReturnSalvar = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            set_centroCustos(null);
            set_grupoeconomico(null);
            set_planoContas([]);
            showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row className="">
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Grupo Econômico</label>
                            <Select
                                name="grupoeconomico"
                                options={options_gruposeconomicos}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_gruposeconomicos.filter(f => f.value == grupoeconomico)}
                                onChange={(o) => handleChangeGrupoEconomico(o)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {grupoeconomico &&
                    <>
                        <h6 className="titleCollapse">Funcionários</h6>
                        <h6>Vendedores</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Salário</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("vendedores_Salario")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.vendedores_Salario : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Comissão</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("vendedores_Comissao")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.vendedores_Comissao : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Outros Pessoal</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("vendedores_OutrosPessoal")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.vendedores_OutrosPessoal : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Férias</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("vendedores_Ferias")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.vendedores_Ferias : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">INSS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("vendedores_INSS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.vendedores_INSS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">FGTS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("vendedores_FGTS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.vendedores_FGTS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Imposto de Renda</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("vendedores_ImpostoDeRenda")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.vendedores_ImpostoDeRenda : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <hr size="10"></hr>
                        <h6>Gerentes</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Salário</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("gerente_Salario")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.gerente_Salario : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Comissão</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("gerente_Comissao")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.gerente_Comissao : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Outros Pessoal</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("gerente_OutrosPessoal")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.gerente_OutrosPessoal : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Férias</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("gerente_Ferias")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.gerente_Ferias : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">INSS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("gerente_INSS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.gerente_INSS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">FGTS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("gerente_FGTS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.gerente_FGTS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Imposto de Renda</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("gerente_ImpostoDeRenda")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.gerente_ImpostoDeRenda : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <hr size="10"></hr>
                        <h6>Caixa</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Salário</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("caixa_Salario")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.caixa_Salario : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Comissão</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("caixa_Comissao")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.caixa_Comissao : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Outros Pessoal</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("caixa_OutrosPessoal")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.caixa_OutrosPessoal : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Férias</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("caixa_Ferias")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.caixa_Ferias : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">INSS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("caixa_INSS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.caixa_INSS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">FGTS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("caixa_FGTS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.caixa_FGTS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Imposto de Renda</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("caixa_ImpostoDeRenda")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.caixa_ImpostoDeRenda : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <hr size="10"></hr>
                        <h6>Administrativo</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Salário</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("administrativo_Salario")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.administrativo_Salario : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Comissão</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("administrativo_Comissao")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.administrativo_Comissao : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Outros Pessoal</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("administrativo_OutrosPessoal")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.administrativo_OutrosPessoal : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Férias</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("administrativo_Ferias")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.administrativo_Ferias : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">INSS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("administrativo_INSS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.administrativo_INSS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">FGTS</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("administrativo_FGTS")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.administrativo_FGTS : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Imposto de Renda</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("administrativo_ImpostoDeRenda")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.administrativo_ImpostoDeRenda : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <h6 className="titleCollapse">Despesa Ocupacional</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Aluguel</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("ocupacional_Aluguel")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.ocupacional_Aluguel : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Condomínio</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("ocupacional_Condominio")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.ocupacional_Condominio : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Fundo Promoção</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("ocupacional_FundoPromocao")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.ocupacional_FundoPromocao : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <h6 className="titleCollapse">Despesa Estrutural</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Telefonia</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Telefonia")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Telefonia : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Limpeza</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Limpeza")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Limpeza : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Manutenção</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Manutencao")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Manutencao : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Materiais</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Materiais")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Materiais : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Energia e Taxas</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_EnergiaTaxas")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_EnergiaTaxas : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Contabilidade</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Contabilidade")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Contabilidade : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Jurídico</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Juridico")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Juridico : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Sistemas</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Sistema")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Sistema : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Ações de Vendas</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_AcoesVenda")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_AcoesVenda : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Seguros</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Seguros")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Seguros : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Motoboy</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Motoboy")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Motoboy : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Outros</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_Outros")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_Outros : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Água e Esgoto</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("estrutural_SaneamentoBasico")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.estrutural_SaneamentoBasico : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <h6 className="titleCollapse">Despesa com Cartão</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Taxa de Cartão MDR</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("financeiro_TaxaCartaoMDR")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.financeiro_TaxaCartaoMDR : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Antecipação de Crédito</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("financeiro_AntecipacaoCredito")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.financeiro_AntecipacaoCredito : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <h6 className="titleCollapse">Pos Ebitda</h6>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Tarifas Bancárias</label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText onClick={() => handleOpenPlanoContasDatasys("financeiro_TarifasBancarias")}><i className="fas fa-search mr-2 text-info"></i></InputGroupText>
                                        </InputGroupAddon>
                                        <Input value={centroCustos ? centroCustos.financeiro_TarifasBancarias : ""} readOnly={true} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                {!isDisable && <Button color="success" type="button" onClick={handleClickSalvar}><i className="fas fa-save"></i>  Salvar</Button>}
                            </Col>
                        </Row>
                    </>
                }
            </div>
            <PlanoContasDatasys isOpen={isOpenPlanoContasDatasys} handleReturn={ReturnPlanoContasDatasys} planoContas={planoContas} disabledRows={planoContasDisabled} planoContasSelected={planoContasSelected}></PlanoContasDatasys>
        </>

    );
}